export default {
  CAREER_LIST_REQUESTED: 'CAREER_LIST_REQUESTED',
  CAREER_LIST_SUCCEEDED: 'CAREER_LIST_SUCCEEDED',
  CAREER_LIST_FAILED: 'CAREER_LIST_FAILED',
};
